module.exports = __webpack_public_path__ + "static/img/success.75825365.webp";